module.exports = __webpack_public_path__ + "static/media/lbintBlackText.6dff49f4.png";